import React, { useState } from "react";
import FrontHeader from "../../shared/FrontHeader/FrontHeader";
import FrontFooter from "../../shared/FrontFooter/FrontFooter";
import { submitContactForm } from "../../../utils/submitContactForm";

function Contact() {
  const [formData, setFormData] = useState({
    name: "",
    phone: "",
    email: "",
    message: "",
    _gotcha: "",
  });
  const [isSubmitting, setIsSubmitting] = useState(false);
  const [submitStatus, setSubmitStatus] = useState<
    "idle" | "success" | "error"
  >("idle");

  const handleChange = (
    e: React.ChangeEvent<HTMLInputElement | HTMLTextAreaElement>,
  ) => {
    const { name, value } = e.target;
    setFormData((prev) => ({ ...prev, [name]: value }));
    setSubmitStatus("idle");
  };

  const handleSubmit = async (e: React.FormEvent) => {
    e.preventDefault();
    if (formData._gotcha) return;

    if (!formData.message.trim()) {
      setSubmitStatus("error");
      return;
    }

    setIsSubmitting(true);
    setSubmitStatus("idle");

    try {
      await submitContactForm({
        nom_complet: formData.name,
        email: formData.email,
        tel: formData.phone,
        message: formData.message,
        subject: "Contact depuis le site",
        source: window.location.hostname || "",
      });
      setSubmitStatus("success");
      setFormData({ name: "", phone: "", email: "", message: "", _gotcha: "" });
    } catch {
      setSubmitStatus("error");
    } finally {
      setIsSubmitting(false);
    }
  };

  return (
    <div className="landing-page-component">
      <FrontHeader />
      <div className="page-content pb-5 pb-5">
        <h1 className="custom-page-title">Contact</h1>
        <div className="container pt-4">
          <div className="row row-contact">
            <div className="col-md-6 col-infos">
              <div className="custom-item">
                <div className="item-sm-title">ADRESSE</div>
                <div className="item-sm-value">
                  Sipres 2, Cité Mourtada Villa Numéro 2 <br />
                  derrière Hypermarché Exclusif
                </div>
              </div>
              <div className="custom-item pt-3">
                <div className="item-sm-title">MOBILE</div>
                <div className="item-sm-value">(+221) 77 531 18 46</div>
              </div>
              <div className="custom-item pt-3">
                <div className="item-sm-title">EMAIL</div>
                <div className="item-sm-value">contact@easymarket.com</div>
              </div>
            </div>
            <div className="col-md-6 col-send">
              <div className="send-message-card">
                <div className="card-title pt-3 pb-5">Envoyer un message</div>
                <form onSubmit={handleSubmit} noValidate>
                  <input
                    type="text"
                    name="_gotcha"
                    value={formData._gotcha}
                    onChange={handleChange}
                    tabIndex={-1}
                    autoComplete="off"
                    aria-hidden="true"
                    style={{ display: "none" }}
                  />
                  <div className="row">
                    <div className="col-md-12">
                      <div className="custom-input-wrapper">
                        <label htmlFor="contact-name" className="card-label">
                          Nom et prénom
                        </label>
                        <input
                          id="contact-name"
                          type="text"
                          name="name"
                          className="card-input"
                          value={formData.name}
                          onChange={handleChange}
                        />
                      </div>
                    </div>
                    <div className="col-md-12 pt-4">
                      <div className="custom-input-wrapper">
                        <label htmlFor="contact-phone" className="card-label">
                          Téléphone
                        </label>
                        <input
                          id="contact-phone"
                          type="tel"
                          name="phone"
                          className="card-input"
                          value={formData.phone}
                          onChange={handleChange}
                        />
                      </div>
                    </div>
                    <div className="col-md-12 pt-4">
                      <div className="custom-input-wrapper">
                        <label htmlFor="contact-email" className="card-label">
                          Entrez votre adresse mail
                        </label>
                        <input
                          id="contact-email"
                          type="email"
                          name="email"
                          className="card-input"
                          value={formData.email}
                          onChange={handleChange}
                        />
                      </div>
                    </div>
                    <div className="col-md-12 pt-4">
                      <div className="custom-input-wrapper">
                        <label htmlFor="contact-message" className="card-label">
                          Votre message
                        </label>
                        <textarea
                          id="contact-message"
                          name="message"
                          className="card-input"
                          rows={8}
                          value={formData.message}
                          onChange={handleChange}
                          required
                        />
                      </div>
                    </div>
                  </div>
                  <div className="btn-container d-flex justify-content-center pt-5 pb-3">
                    <button
                      type="submit"
                      className="submit-btn"
                      disabled={isSubmitting}
                    >
                      {isSubmitting ? "Envoi..." : "Envoyer"}
                    </button>
                  </div>
                  {submitStatus === "success" && (
                    <p
                      className="text-center text-success mb-3"
                      role="status"
                    >
                      Message envoyé. Nous vous recontacterons rapidement.
                    </p>
                  )}
                  {submitStatus === "error" && (
                    <p className="text-center text-danger mb-3" role="alert">
                      L&apos;envoi a échoué. Veuillez réessayer dans quelques
                      instants.
                    </p>
                  )}
                </form>
              </div>
            </div>
          </div>
        </div>
        <div className="maps-container">
          <iframe
            className="maps-frame"
            src="https://www.google.com/maps/embed?pb=!1m18!1m12!1m3!1d3858.4682214196177!2d-17.52284792576366!3d14.742630873585286!2m3!1f0!2f0!3f0!3m2!1i1024!2i768!4f13.1!3m3!1m2!1s0xec112dc3b6aa291%3A0xd7aeda2a6941677!2sYaas%20Hotel%20Dakar%20Almadies!5e0!3m2!1sfr!2ssn!4v1695659353590!5m2!1sfr!2ssn"
            height="500"
            style={{ border: 0 }}
            allowFullScreen={true}
            loading="lazy"
            referrerPolicy="no-referrer-when-downgrade"
            title="Carte ToutDedans"
          />
        </div>
      </div>
      <FrontFooter />
    </div>
  );
}

export default Contact;
